function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
  fill: "#EA4B4B"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M38.5172 18.125C38.5172 18 38.5172 17.875 38.3966 17.75V17.625C38.0345 16.5 37.069 15.75 35.8621 15.75H36.1035C36.1035 15.75 31.3966 15 25 15C18.7241 15 13.8966 15.75 13.8966 15.75H14.1379C12.931 15.75 11.9655 16.5 11.6034 17.625V17.75C11.6034 17.875 11.6034 18 11.4828 18.125C11.3621 19.375 11 22 11 25C11 28 11.3621 30.625 11.4828 31.875C11.4828 32 11.4828 32.125 11.6034 32.25V32.375C11.9655 33.5 12.931 34.25 14.1379 34.25H13.8966C13.8966 34.25 18.6034 35 25 35C31.2759 35 36.1035 34.25 36.1035 34.25H35.8621C37.069 34.25 38.0345 33.5 38.3966 32.375V32.25C38.3966 32.125 38.3966 32 38.5172 31.875C38.6379 30.625 39 28 39 25C39 22 38.7586 19.375 38.5172 18.125ZM29.1035 25.625L23.431 29.875C23.3103 30 23.1897 30 23.069 30C22.9483 30 22.8276 30 22.7069 29.875C22.4655 29.75 22.3448 29.5 22.3448 29.25V20.75C22.3448 20.5 22.4655 20.25 22.7069 20.125C22.9483 20 23.1897 20 23.431 20.125L29.1035 24.375C29.2241 24.5 29.3448 24.75 29.3448 25C29.4655 25.25 29.3448 25.5 29.1035 25.625Z",
  fill: "white"
});

var SvgSourceGoogle = function SvgSourceGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_google.3e6eb103.svg";
export { ForwardRef as ReactComponent };